import BigNumber from 'bignumber.js';
import _keyBy from 'lodash/keyBy';
import config from 'config';
import { GAME } from 'utils/defines';

const LOAD = 'game/info/LOAD';
const LOAD_SUCCESS = 'game/info/LOAD_SUCCESS';
const LOAD_FAIL = 'game/info/LOAD_FAIL';
const GET_ACCESS_AVAILABLE = 'game/info/GET_ACCESS_AVAILABLE';
const GET_ACCESS_AVAILABLE_SUCCESS = 'game/info/GET_ACCESS_AVAILABLE_SUCCESS';
const GET_ACCESS_AVAILABLE_FAIL = 'game/info/GET_ACCESS_AVAILABLE_FAIL';
const I_AM_ADULT = 'game/info/I_AM_ADULT';
const MAINTENANCE = 'game/info/MAINTENANCE';
const SET_GAME = 'game/info/SET_GAME';
const CLEAR_WINNING_FLAG = 'game/info/CLEAR_WINNING_FLAG';

const SAVE_TOAST = 'game/info/SAVE_TOAST';
const CLEAR_SAVED_TOAST = 'game/info/CLEAR_SAVED_TOAST';
const SET_SHOW_STATISTICS = 'game/info/SET_SHOW_STATISTICS';

const defaultMaintenance = {
  code: '0',
  site: [
    {
      name: 'all',
      is_maintenance: 'N',
    },
  ],
  wallet: [
    {
      name: 'moneybutton',
      is_maintenance: 'N',
    },
    {
      name: 'handcash',
      is_maintenance: 'N',
    },
  ],
  game: [
    {
      name: 'bitto',
      is_maintenance: 'N',
    },
    {
      name: 'ladder',
      is_maintenance: 'N',
    },
    {
      name: 'turtle',
      is_maintenance: 'N',
    },
    {
      name: 'baccarat',
      is_maintenance: 'N',
    },
    {
      name: 'dice',
      is_maintenance: 'N',
    },
    {
      name: 'coinflip',
      is_maintenance: 'N',
    },
    {
      name: 'wheel',
      is_maintenance: 'N',
    },
    {
      name: 'roulette',
      is_maintenance: 'N',
    },
  ],
};
const initialState = {
  iAmAdult: false,
  loaded: false,
  maintenance: { ...defaultMaintenance },
  accessAvailable: true,
  game: null,
  oldGame: false,
  data: {
    totalPlayerCount: 0,
    totalBalances: '0',
    min_bet: 0,
    decimal_place: 0,
    max_payout: 0,
    address: null,
  },
  savedToast: [],
  showStatistics: false,
};

export default function info(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true,
      };
    case LOAD_SUCCESS: {
      const newData = {
        ...state.data,
        ...action.result.data,
        ...action.result?.data?.time,
      };

      const interval = action.result?.timestamp * (action.timestampWithMilliSecond ? 1 : 1000) - Date.now();
      // eslint-disable-next-line camelcase
      const endTime = newData?.end_time;
      if (endTime) {
        newData.end_time = new Date(new Date(endTime) - interval).toISOString();
      }

      if (state.game === GAME._BACCARAT) {
        // eslint-disable-next-line camelcase
        const noMoreBets = newData?.no_more_bets;
        if (noMoreBets) {
          newData.no_more_bets = new Date(new Date(noMoreBets) - interval).toISOString();
        }
      } else if (state.game === GAME._LADDER_GAME || state.game === GAME._TURTLE_RACE) {
        newData.no_more_bets = new Date(
          new Date(endTime) - config.noMoreBetsDuration[state.game] * 1000 - interval
        ).toISOString();
      }

      if (state.game === GAME._BITTO) {
        newData.winning_chance_info = _keyBy(newData.winning_chance_info, 'rank');
      } else if (state.game === GAME._BACCARAT) {
        newData.payout = {};
        newData.areas.forEach(data => {
          newData.payout[data.area] = Array.isArray(data.payout_rate)
            ? Math.max(...data.payout_rate)
            : data.payout_rate;
        });
        newData.min_balance = Math.min(...newData.areas.map(area => area.min_balance));
        newData.max_balance = Math.max(...newData.areas.map(area => area.max_balance));
      }

      let totalPlayerCount = 0;
      let totalBalances = new BigNumber(0);
      ['turtles', 'ladders', 'flags', 'dice'].forEach(game => {
        if (!newData[game]) {
          return;
        }
        newData[game].forEach(data => {
          try {
            data.cashAddress = null;
          } catch {
            data.cashAddress = data.address;
          }
          totalPlayerCount += data.player_count;
          totalBalances = totalBalances.plus(data.total_balance);

          if (data.winning_rate) {
            data.winning_rate = new BigNumber(data.winning_rate).toFixed();
          }
        });
      });
      Object.assign(newData, {
        totalPlayerCount,
        totalBalances: totalBalances.toFixed(),
      });

      // // TODO remove this
      // newData.areas.forEach(area => {
      //   area.min_balance = 0.05;
      // });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: newData,
      };
    }
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
      };
    case I_AM_ADULT:
      return {
        ...state,
        iAmAdult: true,
      };
    case MAINTENANCE: {
      const maintenance = { ...defaultMaintenance };
      action.maintenance.split('|').forEach(service => {
        maintenance[service] = true;
      });
      const res = JSON.parse(action.maintenance);
      return {
        ...state,
        maintenance: {
          code: state.maintenance.code,
          site: res?.site,
          wallet: res?.wallet,
          game: res?.game,
        },
      };
    }
    case GET_ACCESS_AVAILABLE_SUCCESS: {
      return {
        ...state,
        maintenance: {
          code: action.result?.code,
          site: action.result?.data?.maintenance.site,
          wallet: action.result?.data?.maintenance.wallet,
          game: action.result?.data?.maintenance.game,
        },
        settings: action.result.data.setting,
      };
    }
    case GET_ACCESS_AVAILABLE_FAIL:
      return {
        ...state,
        ...(action?.error?.status === 403 && { accessAvailable: false }),
      };
    case SET_GAME:
      return {
        ...state,
        game: action.game,
        oldGame: [GAME._BITTO, GAME._TURTLE_RACE, GAME._LADDER_GAME].indexOf(action.game) !== -1,
      };
    case CLEAR_WINNING_FLAG:
      return {
        ...state,
        data: {
          ...state.data,
          winning_flag: null,
        },
      };

    case SAVE_TOAST:
      return {
        ...state,
        savedToast: [...state.savedToast, action.data],
      };

    case CLEAR_SAVED_TOAST:
      return {
        ...state,
        savedToast: [],
      };

    case SET_SHOW_STATISTICS:
      return {
        ...state,
        showStatistics: action.state,
      };

    default:
      return state;
  }
}

export function isLoaded(globalState) {
  return globalState.info && globalState.info.loaded;
}

export function load() {
  return (dispatch, getState) => {
    const state = getState();
    return dispatch({
      types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
      promise: ({ client }) => client.get(`/${state.info.game}/game/info`, {
        params: {
          asset: config.asset,
        },
      }),
    });
  };
}

export function loadDiceSetting() {
  return (dispatch, getState) => {
    const state = getState();
    return dispatch({
      types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
      promise: ({ client }) => client.get(`/v1/${state.info.game}/games/setting`, {
        params: {
          asset: 'BSV',
        },
      }),
      timestampWithMilliSecond: true,
    });
  };
}

export function loadSetting() {
  return (dispatch, getState) => {
    const state = getState();
    if (state.info.game === GAME._DICE) {
      return loadDiceSetting();
    }
    return dispatch({
      types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
      promise: ({ client }) => client.get(`/v2/${state.info.game}/games/current/setting`, {
        params: {
          asset: 'BSV',
        },
      }),
      timestampWithMilliSecond: true,
    });
  };
}

export function iAmAdult() {
  return {
    type: I_AM_ADULT,
  };
}

export function setMaintenance(maintenance) {
  return {
    type: MAINTENANCE,
    maintenance,
  };
}

export function getAccessAvailable() {
  return {
    types: [GET_ACCESS_AVAILABLE, GET_ACCESS_AVAILABLE_SUCCESS, GET_ACCESS_AVAILABLE_FAIL],
    promise: ({ client }) => client.get('/v1/ping'),
  };
}

export function setGame(game) {
  return {
    type: SET_GAME,
    game,
  };
}

export function clearWinningFlag() {
  return {
    type: CLEAR_WINNING_FLAG,
  };
}

export function saveToast(data) {
  return {
    type: SAVE_TOAST,
    data,
  };
}

export function clearSavedToast() {
  return {
    type: CLEAR_SAVED_TOAST,
  };
}

export function setShowStatistics(state) {
  return {
    type: SET_SHOW_STATISTICS,
    state,
  };
}
